type SizeByGrade = {
  [key: string]: {
    wide?: number;
    long?: number;
    size: number;
  };
};

export const sizeByGrade: SizeByGrade = {
  caravan_saver: {
    wide: 10,
    size: 280,
  },
  caravan_bronze: {
    wide: 12,
    size: 420,
  },
  caravan_silver: {
    wide: 12,
    size: 420,
  },
  caravan_gold: {
    wide: 14,
    size: 560,
  },
  caravan_signature: {
    wide: 12,
    size: 420,
  },
  caravan_signature_gold: {
    wide: 14,
    size: 560,
  },
  lodge_emerald: {
    wide: 16,
    long: 40,
    size: 640,
  },
  lodge_diamond: {
    wide: 20,
    long: 40,
    size: 800,
  },
  lodge_signature: {
    wide: 20,
    long: 40,
    size: 800,
  },
};
